import React, { useState } from "react";
import { AdminTableActionIcon } from "../../svgs/AdminTableActionIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

interface IProps {
  viewPatient: () => void;
  deactivatePatient: () => void;
  deletePatient: () => void;
  status: boolean;
}

const AdminPatientsActionCell = ({
  viewPatient,
  deactivatePatient,
  deletePatient,
  status
}: IProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="flex items-center gap-x-4">
      <button
        type="button"
        className="border-none outline-none cursor-pointer"
        onClick={event => {
          event.stopPropagation();
          handleClick(event);
        }}
      >
        <AdminTableActionIcon />
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}
      >
        <MenuItem onClick={viewPatient}>View</MenuItem>
        <MenuItem onClick={deactivatePatient}>
          {status ? "Deactivate" : "Activate"}
        </MenuItem>
        <MenuItem onClick={deletePatient}>Delete</MenuItem>
      </Menu>
    </div>
  );
};

export default AdminPatientsActionCell;
